import { defineMessages } from 'react-intl';

// Moved here from the removed `OrganizationSwitcher` (now opened as a modal
// from the settings dropdown instead of living inline in the sidebar). The
// message ids are kept as `features.organizationSwitcher.*` on purpose — they
// carry existing EN/SR translations, and `translations:extract` matches ids
// wherever they live, not by file path, so renaming them would silently
// revert this content to English until someone re-translates it.
const messages = defineMessages({
  addProfile: {
    id: 'features.organizationSwitcher.addProfile',
    defaultMessage: 'Add profile',
  },
  billingLockedBadge: {
    id: 'features.organizationSwitcher.billingLockedBadge',
    defaultMessage: 'Unpaid balance',
  },
  corpBadge: {
    id: 'features.organizationSwitcher.corpBadge',
    defaultMessage: 'Corp',
  },
  subscriptionEndedBadge: {
    id: 'features.organizationSwitcher.subscriptionEndedBadge',
    defaultMessage: 'Subscription ended',
  },
  personalProfile: {
    id: 'features.organizationSwitcher.personalProfile',
    defaultMessage: 'Personal profile',
  },
  roleClient: {
    id: 'features.organizationSwitcher.role.client',
    defaultMessage: 'Client',
  },
  roleOwner: {
    id: 'features.organizationSwitcher.role.owner',
    defaultMessage: 'Owner',
  },
  roleTrainer: {
    id: 'features.organizationSwitcher.role.trainer',
    defaultMessage: 'Trainer',
  },
  title: {
    id: 'features.organizationSwitcher.title',
    defaultMessage: 'Choose profile',
  },
  searchPlaceholder: {
    id: 'features.switchProfileModal.searchPlaceholder',
    defaultMessage: 'Search organizations',
  },
});

export default messages;
